import { useRouter } from "next/router"
import { type CookieValueTypes, getCookie, hasCookie } from "cookies-next/client"
import { lastDashboardNavigationCookieName } from "../constants/lastDashboardNavigationCookieName"
import { lastDashboardNavigationSchema } from "../schemas/lastDashboardNavigationSchema"

function getLastDashboardNavigationFromCookie(
    lastDashboardNavigationServerCookie: CookieValueTypes
) {
    const lastDashboardNavigationCookie = hasCookie(lastDashboardNavigationCookieName)
        ? getCookie(lastDashboardNavigationCookieName)
        : lastDashboardNavigationServerCookie

    if (lastDashboardNavigationCookie) {
        try {
            const lastDashboardNavigation = JSON.parse(lastDashboardNavigationCookie)

            return lastDashboardNavigationSchema.parse(lastDashboardNavigation)
        } catch (e) {
            console.error("Error parsing lastDashboardNavigation cookie:", e)
        }
    }

    return { accountNumber: "", propertyId: "" }
}

export function useCurrentNavigation(lastDashboardNavigationCookie?: CookieValueTypes) {
    const router = useRouter()
    const lastDashboardNavigation = getLastDashboardNavigationFromCookie(
        lastDashboardNavigationCookie
    )

    return lastDashboardNavigationSchema.parse({
        accountNumber: router.query.accountNumber ?? lastDashboardNavigation.accountNumber,
        propertyId: router.query.propertyId ?? lastDashboardNavigation.propertyId,
        agreementId: router.query.agreementId ?? lastDashboardNavigation.agreementId,
    })
}

useCurrentNavigation.cookies = [lastDashboardNavigationCookieName] as const
